@if (dataSource) {
  <div [ngStyle]="{ overflow: 'auto' }">
    @if (draggable) {
      <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="expansionColumnNames.length > 0" cdkDropList [cdkDropListData]="dataSource" (cdkDropListDropped)="draggable.dropItem($event)">
        @for (entityAccessor of entities; track trackBy(ii); let ii = $index) {
          <ng-container [cdkColumnDef]="entityAccessor.columnDef">
            @if (entityAccessor.header) {
              <th mat-header-cell *cdkHeaderCellDef>{{ entityAccessor.header }}</th>
            }
            @if (entityAccessor.type !== 'expansion') {
              <td mat-cell class="mat-table-td" *cdkCellDef="let entity; let i = index;" (click)="handleRowClick(entityAccessor, entity)">
                <cdk-table-cell
                  [entity]="entity"
                  [entityAccessor]="entityAccessor"
                  [index]="i"
                  (componentEventTriggered)="handleComponentEvent($event, i)"
                ></cdk-table-cell>
              </td>
            }
            @if (entityAccessor.type === 'expansion') {
              <td mat-cell *matCellDef="let entity;" [attr.colspan]="displayColumns.length">
                <cdk-table-extended
                  [entity]="entity"
                  [expandedEntity]="expandedEntity"
                  [renderRowExpansion]="entityAccessor.expansion.renderHtml"
                  [handleRowExpansionClick]="entityAccessor.expansion.elementClick"
                ></cdk-table-extended>
              </td>
            }
            @if (footer) {
              <span>
                <td mat-footer-cell *matFooterCellDef>
                  @if (ii === 0) {
                    <div>{{ footer.label }}</div>
                  }
                  @if (ii === displayColumns.length - 1) {
                    <div>{{ footer.value }}</div>
                  }
                </td>
              </span>
            }
          </ng-container>
        }
        <tr mat-header-row *cdkHeaderRowDef="displayColumns"></tr>
        <tr
          mat-row
          cdkDrag
          [class.element-row]="expansionColumnNames.length > 0"
          [ngStyle]="{ cursor: cursor }"
          *cdkRowDef="let entity; columns: displayColumns"
          (click)="toggleRowExpansion(entity)"
          [cdkDragData]="entity"
          [id]="entity.id"
        ></tr>
        @if (expansionColumnNames.length > 0) {
          <tr mat-row *matRowDef="let row; columns: expansionColumnNames" class="detail-row"></tr>
        }
        @if (footer) {
          <span>
            <tr mat-footer-row *matFooterRowDef="displayColumns"></tr>
          </span>
        }
      </table>
    } @else {
      <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="expansionColumnNames.length > 0">
        @for (entityAccessor of entities; track trackBy(ii); let ii = $index) {
          <ng-container [cdkColumnDef]="entityAccessor.columnDef">
            @if (entityAccessor.header) {
              <th mat-header-cell *cdkHeaderCellDef><cdk-table-header [header]="entityAccessor.header"></cdk-table-header></th>
            }
            @if (entityAccessor.type !== 'expansion') {
              <td mat-cell class="mat-table-td" *cdkCellDef="let entity; let i = index;" (click)="handleRowClick(entityAccessor, entity)">
                <cdk-table-cell
                  [entity]="entity"
                  [entityAccessor]="entityAccessor"
                  [index]="i"
                  (componentEventTriggered)="handleComponentEvent($event, i)"
                ></cdk-table-cell>
              </td>
            }
            @if (entityAccessor.type === 'expansion') {
              <td mat-cell *matCellDef="let entity;" [attr.colspan]="displayColumns.length">
                <cdk-table-extended
                  [entity]="entity"
                  [expandedEntity]="expandedEntity"
                  [renderRowExpansion]="entityAccessor.expansion.renderHtml"
                  [handleRowExpansionClick]="entityAccessor.expansion.elementClick"
                ></cdk-table-extended>
              </td>
            }
            @if (footer) {
              <span>
                <td mat-footer-cell *matFooterCellDef>
                  @if (ii === 0) {
                    <div>{{ footer.label }}</div>
                  }
                  @if (ii === displayColumns.length - headerDiff) {
                    <div>{{ footer.value }}</div>
                  }
                </td>
              </span>
            }
          </ng-container>
        }
        <tr mat-header-row *cdkHeaderRowDef="displayColumns"></tr>
        <tr
          mat-row
          [class.element-row]="expansionColumnNames.length > 0"
          [ngStyle]="{ cursor: cursor }"
          *cdkRowDef="let entity; columns: displayColumns"
          (click)="toggleRowExpansion(entity)"
          [id]="entity.id"
        ></tr>
        @if (expansionColumnNames.length > 0) {
          <tr mat-row *matRowDef="let row; columns: expansionColumnNames" class="detail-row"></tr>
        }
        @if (footer) {
          <span>
            <tr mat-footer-row *matFooterRowDef="displayColumns"></tr>
          </span>
        }
      </table>
    }
  </div>
}
